export default __webpack_public_path__ + "static/media/sparck-appreciation-card-header-3.946de3b7.png";